import React, { useState, useEffect, useCallback } from 'react';
import { adminAPI } from '../../services/api';
import AdminLayout from '../../components/admin/AdminLayout';
import {
  Wallet,
  Zap,
  BarChart3,
  Calendar,
  Loader,
  RefreshCw
} from 'lucide-react';

function CostsPage() {
  const [costs, setCosts] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCosts = useCallback(async () => {
    try {
      const res = await adminAPI.getCosts();
      setCosts(res.data);
    } catch (error) {
      console.error('Error fetching costs:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCosts();
    // Polling cada 30 segundos para reflejar consumo de otros usuarios
    const interval = setInterval(fetchCosts, 30000);
    return () => clearInterval(interval);
  }, [fetchCosts]);

  if (loading) {
    return (
      <AdminLayout title={<h1>Costos y Consumo</h1>}>
        <div className="admin-loading">
          <Loader size={32} className="loading-spinner" />
          <p>Cargando costos...</p>
        </div>
      </AdminLayout>
    );
  }

  const { monthlyLimit, totalConsumed, available, percentage, requestCount, avgCostPerRequest } = costs || {};

  return (
    <AdminLayout title={<h1>Costos y Consumo</h1>}>
      <div className="costs-page-content">
        {/* Credits Card */}
        <div className="config-card costs-main-card">
          <div className="config-card-header">
            <div className="config-card-icon" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
              <Wallet size={24} />
            </div>
            <div>
              <h2>Cr&eacute;ditos Disponibles</h2>
              <p>Consumo aprox. de tokens</p>
            </div>
            <button
              className="costs-refresh-btn"
              onClick={fetchCosts}
              title="Actualizar"
            >
              <RefreshCw size={16} />
            </button>
          </div>
          <div className="credits-display">
            <div className="credits-amount">
              <span className="credits-value">
                ${(available || 0).toLocaleString('es-CO')}
              </span>
              <span className="credits-currency">Pesos colombianos (COP)</span>
            </div>
            <div className="credits-bar-wrapper">
              <div className="credits-bar-labels">
                <span>Consumido ${(totalConsumed || 0).toLocaleString('es-CO')} de ${(monthlyLimit || 0).toLocaleString('es-CO')}</span>
                <span>{percentage || 0}%</span>
              </div>
              <div className="credits-bar">
                <div
                  className="credits-bar-fill"
                  style={{ width: `${percentage || 0}%` }}
                />
              </div>
            </div>
          </div>
          <div className="credits-details">
            <div className="credits-detail-item">
              <span>Plan</span>
              <span>B&aacute;sico</span>
            </div>
            <div className="credits-detail-item">
              <span>L&iacute;mite mensual</span>
              <span>${(monthlyLimit || 0).toLocaleString('es-CO')} COP</span>
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="costs-stats-grid">
          <div className="config-card costs-stat-card">
            <div className="costs-stat-icon" style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6' }}>
              <Zap size={20} />
            </div>
            <div className="costs-stat-info">
              <span className="costs-stat-value">{(requestCount || 0).toLocaleString('es-CO')}</span>
              <span className="costs-stat-label">Consultas realizadas</span>
            </div>
          </div>

          <div className="config-card costs-stat-card">
            <div className="costs-stat-icon" style={{ background: 'rgba(16, 163, 127, 0.1)', color: '#10a37f' }}>
              <BarChart3 size={20} />
            </div>
            <div className="costs-stat-info">
              <span className="costs-stat-value">${(avgCostPerRequest || 0).toLocaleString('es-CO')}</span>
              <span className="costs-stat-label">Costo promedio por consulta</span>
            </div>
          </div>

          <div className="config-card costs-stat-card">
            <div className="costs-stat-icon" style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
              <Wallet size={20} />
            </div>
            <div className="costs-stat-info">
              <span className="costs-stat-value">${(totalConsumed || 0).toLocaleString('es-CO')}</span>
              <span className="costs-stat-label">Consumido este mes</span>
            </div>
          </div>

          <div className="config-card costs-stat-card">
            <div className="costs-stat-icon" style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6' }}>
              <Calendar size={20} />
            </div>
            <div className="costs-stat-info">
              <span className="costs-stat-value">20 d&iacute;as</span>
              <span className="costs-stat-label">Para renovaci&oacute;n</span>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default CostsPage;
